import { render, staticRenderFns } from "./ActivityGoodsAddPage.vue?vue&type=template&id=6cdf3fe7&scoped=true&"
import script from "./ActivityGoodsAddPage.vue?vue&type=script&lang=js&"
export * from "./ActivityGoodsAddPage.vue?vue&type=script&lang=js&"
import style0 from "./ActivityGoodsAddPage.vue?vue&type=style&index=0&id=6cdf3fe7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cdf3fe7",
  null
  
)

export default component.exports